import utils from "./utils";

export const objectTransformer = {
  format: (v) => v || {},
  parse: (v) => v,
};

export const stringArrayTransformer = {
  format: (v) => {
    if (typeof v === "string") {
      return v.split("\n");
    }
    return v || [];
  },
  parse: (v) => v,
};

export const booleanTransformer = {
  format: (v) => {
    return utils.isChecked(v);
  },
  parse: (v) => v,
};

export const jsonTransformer = {
  format: (v) => (typeof v === "string" ? v : JSON.stringify(v || {}, null, 2)),
  parse: (v) => {
    try {
      const value = JSON.parse(v);
      return value;
    } catch (err) {
      return {};
    }
  },
};



// WEBPACK FOOTER //
// ./app/lib/fieldTransformers.js